import { dataExpandAlt } from 'dls-icons-data'
import { createIcon } from '../common'

const IconExpandAlt = /*#__PURE__*/createIcon(dataExpandAlt)
export default IconExpandAlt
